import { Component, OnInit } from '@angular/core';

import { ActivatedRoute } from '@angular/router';
import { BaseCtl } from '../base.component';
import { GlobalConstants } from '../GlobalConstants ';
import { EventService } from '../service/event.service';
import { ServiceLocatorService } from '../service/service-locator.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent extends BaseCtl {

  public param = "";

  constructor(public locator: ServiceLocatorService,
    private eService: EventService, public route: ActivatedRoute) {
    super(locator.endpoints.AUTH, locator, route);
    let _self = this;
    //this.form.preload["applist"] = [];
    locator.getPathVariable(route, function (params) {
      _self.param = params["param"];
      if ('logout' === _self.param) {
        _self.logout();
      } else if ( "session" === _self.param) {
        localStorage.clear();
        _self.form.error = true;
        _self.form.message = 'OOPS your session is expired';
      } else if (_self.param != null && _self.param.length > 10) {
        console.log("----->", _self.param);
        _self.keyLogin(_self.param);
      }
    });

  }

  ngOnInit() {
    let _self = this;
    let uc = localStorage.getItem('userContext');
    if (uc != null) {
      _self.locator.router.navigateByUrl('/dashboard');
    }
  }

  populateForm(form, data) {
    super.populateForm(form, data);
    form.data.loginId = data.loginId;
    form.data.password = data.password;
  }

  /**
   * Sign in a user
   */
  signIn() {
    var _self = this;
    console.log('signIn', this.form);

    let url =  this.locator.endpoints.AUTH + "/sso/login";
    
    //let url = this.locator.endpoints.getEndpoint(this.locator.endpoints.AUTH, "sso/login");

    this.locator.http.post(url, this.form.data, function (res, error) {

      if (error) {
        alert("Server Error:" + error);
        return;
      }

      //console.log(res);
      _self.form.message = '';
      _self.form.inputerror = {};

      //console.log("1");
      _self.form.error = !res.success;
      if (_self.locator.dataValidator.isNotNullObject(res.result.message)) {
        _self.form.message = res.result.message;
      }

      //console.log("2");
      if (_self.locator.dataValidator.isNotNullObject(res.result.inputerror)) {
        _self.form.inputerror = res.result.inputerror;
      }

      if (_self.locator.dataValidator.isTrue(res.success)) {
        //console.log("4");
        localStorage.setItem(GlobalConstants.getKey('loginId'), res.result.data.loginId);
        localStorage.setItem( GlobalConstants.getKey('sessionId'), res.result.jsessionid);
        localStorage.setItem(GlobalConstants.getKey('skey'), res.result.data.skey);
        localStorage.setItem(GlobalConstants.getKey('appId'), res.result.data.appId);
        localStorage.setItem(GlobalConstants.getKey('roleId'), res.result.data.defaultRoleId);
        let str = JSON.stringify(res.result.data);
        localStorage.setItem(GlobalConstants.getKey('userContext'), str);
        _self.locator.userContext = JSON.parse(str);
        _self.eService.menuChanged("");
        _self.locator.router.navigateByUrl('/dashboard');
      }
    });
  }

  keyLogin(skey) {
    var _self = this;
    let url = _self.api.endpoint + "/sso/login/" + skey;
    this.locator.http.get(url, function (res, error) {
      if (error) {
        return;
      }

      //console.log(res);
      _self.form.message = '';
      _self.form.inputerror = {};

      //console.log("1");
      _self.form.error = !res.success;
      if (_self.locator.dataValidator.isNotNullObject(res.result.message)) {
        _self.form.message = res.result.message;
      }

      //console.log("2");
      if (_self.locator.dataValidator.isNotNullObject(res.result.inputerror)) {
        _self.form.inputerror = res.result.inputerror;
      }

      if (_self.locator.dataValidator.isTrue(res.success)) {
        //console.log("4");
        localStorage.setItem(GlobalConstants.getKey('loginId'), res.result.data.loginId);
        localStorage.setItem(GlobalConstants.getKey('sessionId'), res.result.jsessionid);
        localStorage.setItem(GlobalConstants.getKey('skey'), res.result.data.skey);
        localStorage.setItem(GlobalConstants.getKey('appId'), res.result.data.appId);
        localStorage.setItem(GlobalConstants.getKey('roleId'), res.result.data.defaultRoleId);
        let str = JSON.stringify(res.result.data);
        localStorage.setItem(GlobalConstants.getKey('userContext'), str);
        _self.locator.userContext = JSON.parse(str);
        _self.eService.menuChanged("");
        _self.locator.router.navigateByUrl('/dashboard');
      }


    });
  }
  /**
   * Logout a user
   */
  logout() {
    let _self = this;
    let skey =  localStorage.getItem(GlobalConstants.getKey('skey'));
    let url = this.locator.endpoints.getEndpoint(this.locator.endpoints.AUTH, "sso/logout/" + skey);
    this.locator.http.get(url, function (res, error) {
      if (error) {
        return;
      }
      localStorage.clear();
      _self.locator.userContext = {};
      _self.eService.menuChanged("");
      _self.locator.router.navigateByUrl('/login');
    });
  }

}
